import { SHA256 } from 'crypto-js'

const hashPassword = async password => {
  const hash = await SHA256(password).toString()

  return hash
}

export default hashPassword
